module.exports = __webpack_public_path__ + "img/0-43.5bb87858.jpg";